import './components/burger.js';
import './components/cokkie.js';
import './components/fixed-header.js';
import './components/preloader.js';
import './components/counter.js';
import './components/audience.js';
import './components/calendar-slider.js';
import './components/accordion.js';
import './components/tabs.js';
import './components/website-map.js';
import './components/current-year.js';
import './components/rates-form.js';
import './components/footer-accrodion.js';
